import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import FileInput from "@icarius-common/fileUpload/fileInput";
import FileList from "@icarius-common/fileUpload/fileList";
import TextEditor from "@icarius-common/textEditor";

const gridStyle = { padding: 10 };

const SolveExerciseDialog = (props) => {

  const {
    open,
    activityData,
    handleSubmit,
    handleClose,
  } = props;

  const dispatch = useDispatch();
  const [answer, setAnswer] = useState("");
  const [files, setFiles] = useState(null);

  const getFormDataToSend = () => {
    const formDataToSend = new FormData();
    formDataToSend.append("answer", answer ? JSON.stringify(answer) : "");
    if (files?.length) {
      formDataToSend.append("file", files[0]);
    }

    return formDataToSend;
  }

  const submit = () => {
    if (!answer && !files.length) {
      dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
      return;
    }

    handleSubmit(getFormDataToSend());
    handleClose();
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      maxWidth={"md"}
      fullWidth={true}
    >
      <div className={"dialog-container"}>
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {getLocalizedString("solveExercise")}: {activityData.name}
          <DialogTitleDivider />
        </DialogTitle>
        <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
        <DialogContent>
          <Grid container item xs={12}>
            <Grid container item alignItems="center" xs={12} style={gridStyle}>
              <div style={{ width: "100%" }}>
                <TextEditor
                  allowImages
                  initialValue={answer}
                  placeholder={getLocalizedString("enterAnswer")}
                  handleChange={(value) => setAnswer(value)}
                />
              </div>
            </Grid>
            <Grid container item alignItems="center" xs={12} style={gridStyle}>
              <FileInput
                required={!answer}
                acceptedFormats={[
                  ".jpg",
                  ".bmp",
                  ".png",
                  ".jpeg",
                  ".rar",
                  ".zip",
                  ".gz",
                  ".tar",
                  ".xls",
                  ".xlsx",
                  ".txt",
                  ".rtf",
                  ".doc",
                  ".docx",
                  ".pdf",
                  ".html",
                  ".ppt",
                  ".pptx",
                ]}
                handleChange={(files) => setFiles(files)}
                id={"exerciseFile"}
              />
              <FileList
                files={files}
                handleClick={() => setFiles(null)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
          <ButtonDialogAction onClick={submit} isAccept text={getLocalizedString("accept")} />
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default SolveExerciseDialog;